var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"object-list"},[_c('div',{staticClass:"container"},[_c('the-breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('h1',{staticClass:"page-title"},[_vm._v("Search")]),_c('p',{staticClass:"page-description",domProps:{"innerHTML":_vm._s(_vm.pageDescription)}}),_c('archive-list')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }